<template lang="pug">
div
  v-menu(v-model="show" rounded="lg" allow-overflow :close-on-content-click="false" offset-y content-class="border-menu" max-height="345")
    template(#activator="{ on, attrs }")
      v-sheet.text-md.round-xl.border-menu(v-bind="attrs" v-on="on" flat outlined height="48" min-width="240")
        .d-flex.align-center.fill-height.text-sm.px-3
          .flex-grow-1.text-left(v-if="value") {{ showValue(value) }}
          .flex-grow-1.neutral500--text.text-left(v-else) Enter patient name, NRIC or phone number
          v-icon(size="20") $yzi-chevron-down
    .text-xs.white
      .search-input
        v-text-field.mb-2.mx-4.text-sm.round-xl(v-model="searchPatient" outlined :placeholder="$t('search_or_add_new')" autofocus dense hide-details)
        template(v-if="!isHq")
          v-divider
          div.px-4.py-3
            a.info--text.font-semibold(@click="addNewNric") Add new patient
        v-divider
      .d-flex.align-center.px-4.py-3
        .font-semibold Existing patient
        y-pagination(v-model="page" :pageSize="fetchCount" :count="count" :loading="isFetching")
      v-divider
      div.d-flex.justify-center(v-if="isFetching")
        v-progress-linear(:width="3" rounded color="primary" indeterminate)
      //- template(v-else)
      div(v-for="item in patients")
        div.px-4.py-3(v-if="isItemDisabled(item)" style="background-color: var(--v-infoT08)")
          .text-sm.neutral700--text {{ item.name }}
          v-row.mt-1(no-gutters)
            v-col(cols="4" v-if="item.ic")
              div.d-flex.align-center
                v-icon(size="15" color="var(-v-neutral500)") $yzi-user-03
                .text-xs.neutral500--text.ml-1 {{ item.ic }}
            v-col(v-if="item.phone")
              div.d-flex.align-center
                v-icon(size="15" color="var(-v-neutral500)") $yzi-phone
                .text-xs.neutral500--text.ml-1 +{{ item.phone }}
        div.px-4.py-3.clickable.hover-bg(v-else @click="selectItem(item)")
          .text-sm.neutral700--text {{ item.name }}
          v-row.mt-1(no-gutters)
            v-col(cols="4" v-if="item.ic")
              div.d-flex.align-center
                v-icon(size="15" color="var(-v-neutral500)") $yzi-user-03
                .text-xs.neutral500--text.ml-1 {{ item.ic }}
            v-col(v-if="item.phone")
              div.d-flex.align-center
                v-icon(size="15" color="var(-v-neutral500)") $yzi-phone
                .text-xs.neutral500--text.ml-1 +{{ item.phone }}
        v-divider
      template(v-if="!patients.length")
        .px-4.py-3 No results match

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'

export default {
  props: ['value'],
  data: () => ({
    searchPatient: null,
    show: false,
    isFetching: false,
    isLoading: false,
    page: 1,
    fetchCount: 20,
    count: 0,
    patients: []
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      systemProviders: 'clinic/getSystemProviders',
      isHq: 'hq/getIsHq',
      hqSelectedCompany: 'hq/getSelectedCompany'
    })
  },
  watch: {
    show (val) {
      if (val) {
        this.fetchPatients(this.searchPatient)
      } else {
        if (this.value) {
          this.searchPatient = typeof this.value === 'object' ? this.value.name : this.value
        }
        this.$emit('change')
      }
    },
    page () {
      this.fetchPatients(this.searchPatient)
    },
    searchPatient () {
      this.searchStart()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPatients (val) {
      this.isFetching = true
      let params = {
        fields: 'id,name,ic,phone',
        search: val || '',
        page: this.page
      }
      if (!val) {
        params.ordering = '-created'
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      this.$axios.get(`/clinics/${companySlug}/patients`, { params })
        .then(resp => {
          this.patients = resp.data.results
          this.count = resp.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    searchStart: debounce(function () {
      this.page = 1
      this.fetchPatients(this.searchPatient)
    }, 750),
    selectItem (item) {
      this.$emit('input', item)
      this.show = false
      // this.searchPatient = item.ic
    },
    showValue (val) {
      if (typeof val === 'object') {
        return val.name
      } else {
        return val
      }
    },
    isItemDisabled(item) {
      let comp1 = null
      let comp2 = null
      if (this.value && typeof this.value === 'object') {
        comp1 = this.value?.id
      } else {
        comp1 = this.value
      }
      if (item && typeof item === 'object') {
        comp2 = item?.id
      } else {
        comp2 = item
      }
      return comp1 === comp2
    },
    addNewNric () {
      this.$emit('input', null)
      this.$emit('add')
      this.show = false
    }
  }
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.search-input {
  position: sticky;
  top: 0px;
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  z-index: 4;
  padding-top: 8px;
}
</style>